export interface OpenSourcePackage {
  id: string;
  i18nKey: string;
  githubUrl: string;
  demoPath: string;
  platform: string;
}

export const activityHeatmapCalendar: OpenSourcePackage = {
  id: 'activity-heatmap-calendar',
  i18nKey: 'activityHeatmapCalendar',
  githubUrl: 'https://github.com/SynorLab/activity_heatmap_calendar',
  demoPath: '/open-source/activity-heatmap-calendar',
  platform: 'Flutter',
};

export const openSourcePackages: OpenSourcePackage[] = [activityHeatmapCalendar];
